import DocsHome from '@/components/Docs/DocsHome';

export default DocsHome;
